export default __webpack_public_path__ + "static/media/create-nft.19a06e20.png";